import React, { useEffect } from 'react';
import { isNil } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Typography, Button } from '@material-ui/core';
import MortgageSurveyQuestionPresenter from 'presenters/MortgageSurveyQuestionPresenter';
import InputWithSlider from 'sharedComponents/InputWithSlider';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useStyles from './useStyles';

const CASH_OUT_MAX_RATIO = 0.8;

const CashOutAmountQuestion = props => {
  const { question, onChange, surveyValues, onValidate, onNext, isValid } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const [cashOutAmountField, DownPaymentTargetField] = MortgageSurveyQuestionPresenter.surveyValueFields(question);
  const currentValue = MortgageSurveyPresenter[cashOutAmountField](surveyValues);
  const priceTarget = MortgageSurveyPresenter.priceTarget(surveyValues);
  const mortgageBalance = MortgageSurveyPresenter.mortgageBalance(surveyValues);
  const calculatedDownPaymentTarget = priceTarget - mortgageBalance - currentValue;

  const options = MortgageSurveyQuestionPresenter.options(question);
  const { min, marksDivider } = options;
  const max = Math.round(priceTarget * CASH_OUT_MAX_RATIO - mortgageBalance);

  useEffect(() => {
    const cashOutAmount = isNil(currentValue) ? 0 : currentValue;
    onChange([
      { field: cashOutAmountField, value: cashOutAmount },
      { field: DownPaymentTargetField, value: calculatedDownPaymentTarget },
    ]);
  }, []);

  useEffect(() => {
    const isValueValid = !isBlank(currentValue) && currentValue <= max && currentValue > 0;
    onValidate(isValueValid);
  }, [currentValue]);

  const handleValueChange = value => {
    const newDownPaymentTarget = priceTarget - mortgageBalance - value;
    onChange([{ field: cashOutAmountField, value }, { field: DownPaymentTargetField, value: newDownPaymentTarget }]);
  };

  return (
    <Box width="100%">
      <Typography variant="h1">{MortgageSurveyQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{MortgageSurveyQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <InputWithSlider
        className={classes.input}
        value={currentValue}
        min={min}
        max={max}
        marksDivider={marksDivider}
        label={MortgageSurveyQuestionPresenter.inputLabel(question)}
        onChange={handleValueChange}
      />
      <Box width="100%" className={classes.buttonBox}>
        <Button onClick={onNext} className={classes.button} variant="contained" disabled={!isValid}>
          {t('components.MortgageSurvey.ControlBar.nextButton')}
        </Button>
      </Box>
    </Box>
  );
};

CashOutAmountQuestion.propTypes = {
  question: MortgageSurveyQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default CashOutAmountQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/CashOutAmountQuestion/CashOutAmountQuestion.js